export const PLACEHOLDER_VIDEO_URL =
  'https://sdqdhpjmecqrrhztqhbc.supabase.co/storage/v1/object/public/exercise-videos/placeholder.mp4';
